<div class="checkout-group">
  <div class="checkout-group-title">
    {{ 'checkout.group.orderType.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body" id="checkout-order-type-group-body-wrapper">
    <div class="app-cover" [class.show-cover]="this.hasPlacedOrder"></div>
    <app-dynamic-form
      (formGroupEmit)="updateFormGroup($event)"
      (formModelEmit)="updateFormModel($event)"
      [formGroupId]="'CHECKOUT_ORDER_TYPE'"
      [static]="false"
      [activeLanguage]="activeLanguage$ | async"
    ></app-dynamic-form>
  </div>
</div>
